module.exports = __webpack_public_path__ + "static/media/railEndCap.6fff0dff.png";